import { EORDER_STATUS, EORDER_TYPE } from "@constants";
import { IOrder } from "../interface/IOrder";

export interface IOrderOfferResponse {
    description: string;
    name: string;
    oneOffChargeAmount: number;
    recurringChargeAmount: number;
    upFrontChargeAmount: number;
}

export interface IOrderResponse {
    createdDateTime: string;
    offers: IOrderOfferResponse[];
    orderType: keyof typeof EORDER_TYPE;
    reference: string;
    status: keyof typeof EORDER_STATUS;
    totalOneOffChargeAmount: number;
    totalRecurringChargeAmount: number;
    totalUpFrontChargeAmount: number;
}

export interface IOrderListResponse {
    page: {
        content: IOrderResponse[];
        first: boolean;
        last: boolean;
        number: number;
        numberOfElements: number;
        size: number;
        totalElements: number;
        totalPages: number;
    };
}

export const getResponseToState = (response: IOrderListResponse): IOrder[] =>
    response.page.content.map((order) => ({
        createdDateTime: order.createdDateTime,
        offers: order.offers
            ? order.offers.map((offer) => ({
                  description: offer.description,
                  name: offer.name,
                  oneOffChargeAmount: offer.oneOffChargeAmount,
                  recurringChargeAmount: offer.recurringChargeAmount,
                  upFrontChargeAmount: offer.upFrontChargeAmount,
              }))
            : [],
        orderType: order.orderType,
        reference: order.reference,
        status: order.status,
        totalOneOffChargeAmount: order.totalOneOffChargeAmount,
        totalRecurringChargeAmount: order.totalRecurringChargeAmount,
        totalUpFrontChargeAmount: order.totalUpFrontChargeAmount,
    }));
